import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip, Button } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

const OpenQualificationSideBarLinkContainer = styled.div`
    &.swTable-linkOut {
        right: 8px;
        position: absolute;
        top: calc(50% - 14px);
    }
    &:hover {
        cursor: pointer;
        .SWReactIcons svg {
            > path:nth-child(1) {
                fill: ${colorsPalettes.blue[500]};
            }
        }
    }
    .SWReactIcons svg {
        width: 28px;
        height: 28px;
        > path:nth-child(1) {
            fill: ${colorsPalettes.blue[400]};
        }
    }
    .button-text {
        font-size: 14px;
        color: ${colorsPalettes.carbon[500]};
    }
`;

interface QualificationSideBarCellButtonProps {
    domain: string;
    favicon: string;
    handleOpenQualificationSideBar: (row: any) => void;
    customTooltipTranslationKey?: string;
    buttonText?: string;
}

export const QualificationSideBarCellButton: FC<QualificationSideBarCellButtonProps> = ({
    domain,
    favicon,
    handleOpenQualificationSideBar,
    customTooltipTranslationKey = "qualification.sidebar.table.cell.link.tooltip",
    buttonText,
}) => {
    return (
        <PlainTooltip
            placement="top"
            tooltipContent={i18nFilter()(customTooltipTranslationKey)}
        >
            <OpenQualificationSideBarLinkContainer
                className="u-vAlignMiddle swTable-linkOut qualification-sidebar-toggle"
                onClick={() => {
                    allTrackers.dispatchTrackEvent("Expanded Side Bar", "open", `open/button/${domain || ""}`);
                    handleOpenQualificationSideBar({
                        Domain: domain,
                        Favicon: favicon,
                    });
                }}
            >
                {buttonText ? (
                    <Button type={"primary"}>{i18nFilter()(buttonText)}</Button>
                ) : (
                    <SWReactIcons iconName="show-details" />
                )}
            </OpenQualificationSideBarLinkContainer>
        </PlainTooltip>
    );
};

QualificationSideBarCellButton.displayName = "QualificationSideBarCellButton";
